import { h } from 'preact'
import { connect } from 'react-redux'

import Button from '../../../shared/components/Button.jsx'
import { error } from '../state/actions/status.js'

import '../style/components/Error.less'

const Error = ({ errorMessage, clear }) => {
	const handleClick = (e) => {
		e.preventDefault()
		clear()
	}

	return (
		<section class="Error">
			<div class="error-icon">⚠</div>
			<p dangerouslySetInnerHTML={{ __html: errorMessage }}></p>
			<Button label="OK" onClick={ handleClick } />
		</section>
	)
}

const mapDispatchToProps = dispatch => ({
	clear: () => dispatch(error(null))
})

export default connect(
	null,
	mapDispatchToProps
)(Error)
